import * as types from './types';
import { loading as loadingAction } from 'State/actions';
import { get } from 'lodash';
import { toastError } from 'Common/ToastHelper';

export const loading = isLoading =>
  loadingAction(types.ASSIGN_SERVED_ITEMS_TO_SITE_FETCHING, isLoading);

export const getSelectServedItemsTableData = siteId => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(true));

    try {
      // Make the api calls at the same time.
      const servedItemsPromise = MPWWebApi.getGeneric('serveditem/all');
      const sitesServedItemsPromise = MPWWebApi.getGeneric(
        `sitemaster/${siteId}/serveditems`
      );

      // Wait for the promises to resolve before dispatching with the results.
      const sitesServedItemsResponse = await sitesServedItemsPromise;
      const servedItemsResponse = await servedItemsPromise;

      dispatch({
        type: types.ASSIGN_SERVED_ITEMS_TO_SITE_GET_DATA,
        payload: {
          servedItems: servedItemsResponse.data.Data,
        },
      });

      dispatch({
        type: types.ASSIGN_SERVED_ITEMS_TO_SITE_GET_SITES_SERVED_ITEMS,
        payload: {
          selectedServedItems: sitesServedItemsResponse.data.Data,
        },
      });
    } catch (error) {
      get(error, 'response.data.Errors', [
        { Title: error.response.statusText },
      ]).forEach(error => toastError(error.Title));
    }

    dispatch(loading(false));
  };
};



// WEBPACK FOOTER //
// ./src/pages/serveditemaccesssetup/state/servedItemsToSite/actions.js